import { render, staticRenderFns } from "./PermanentExhibition.vue?vue&type=template&id=17317192&scoped=true&"
import script from "./PermanentExhibition.vue?vue&type=script&lang=js&"
export * from "./PermanentExhibition.vue?vue&type=script&lang=js&"
import style0 from "./PermanentExhibition.vue?vue&type=style&index=0&id=17317192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17317192",
  null
  
)

export default component.exports